import React, { useState, useEffect } from "react";
import useApi from "../hooks/useApi";
import styles from "../styles/components/VariantGrid.module.css";

import VariantGridItem from "./VariantGridItem";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const VariantGrid = ({ id, minColumns, updatePrompt }) => {
  const { get } = useApi();

  const [processing, setProcessing] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [character, setCharacter] = useState(null);
  const navigate = useNavigate();
  

  const { items, status } = useSelector((state) => state.characters);
  const characterData = items.find((char) => char.id == id);
  const variants = character
    ? [
        character[0].variant_1,
        character[0].variant_2,
        character[0].variant_3,
        character[0].variant_4,
      ]
    : [null, null, null, null];

  useEffect(() => {
    if (character) setCharacter(null);
    setShowGrid(id !== undefined);

    const getCharacter = async () => {
      const response = await get(`/webapp/characters/2d/${id}/`);

      setCharacter(
        response.variants[0].variant_1 == null ? null : response.variants
      );
      
      setProcessing(response.variants[0].processing);
      updatePrompt(response.variants[0].prompt);
    };

    if (status === "succeeded" && characterData) {
      if (characterData) {
      // if (characterData && !characterData.processing) {
        console.log("Character processing completed:", characterData);
        getCharacter();
      }
    }

    // if (status === "failed") {
    //   console.error("Error al cargar personajes");
    // }
  }, [status, characterData, id, updatePrompt]);

  const checkPreview = (variant, index) => {
    if(!variant) return;
    if(!variant.character) return;
    if(variant.character.processing) return;
    // if(!variant.character.processing && !variant.character.success && !variant.character.has_3d) return;
    
    navigate(`/character/${id}/variant/${index}`);
  };

  const validVariants = variants.filter((variant) => variant && variant.url).length;
  const columns = validVariants > 0 ? Math.ceil(validVariants / 2) : 2;

  // console.log("####")
  // console.log(variants)
  // console.log(variants.length)
  // console.log(validVariants)
  // console.log(columns)
  // console.log("####")

  if(!showGrid) return <></>

  return (
    <div className={styles.gridContainer}
        style={{
          gridTemplateColumns: `repeat(${columns}, 1fr)`
        }}>
      {variants.map((variant, variant_index) => {
        if(variant_index < validVariants){
          // const variant = variants[variant_index];
          return <VariantGridItem
            key={variant_index}
            variant={variant}
            index={variant_index + 1}
            goToPreview={checkPreview}
            />
          }else if(validVariants === 0){
            return <VariantGridItem
              key={variant_index}
              index={variant_index + 1}
              goToPreview={checkPreview}
              processing={true}
            />
        }
      })}
    </div>
  );
};

export default VariantGrid;
